import { useEffect, useRef } from 'react';
import { renderHeatmap, type HeatmapPoint } from '@/lib/heatmap-render';

interface Props {
  points: HeatmapPoint[];
  width: number;
  height: number;
  className?: string;
}

export function HeatmapCanvas({ points, width, height, className }: Props) {
  const ref = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    canvas.width = width;
    canvas.height = height;
    renderHeatmap({ canvas, points });
  }, [points, width, height]);

  return <canvas ref={ref} className={className} aria-hidden />;
}
